<template>
    <div class="home-component">
        <div class="app-header-nav-bar">
                <div class="spacer"></div>
                <div class="container">
                    <a href="event-schedule" class="your-account-nav-bar"> イベントスケジュール</a>
                </div>
        </div>

        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="150">
        </div>

        <div class="enter-membership-form">
            <div class="upcoming-events-title">
                アカウント情報
            </div>


            <div class="first-name-container">
                <div id="first-name-label" class="first-name">
                    名前: 
                </div>

                <div id="first-name" class="first-name-value">
                    
                </div>
            </div>

            <div class="first-name-container">
                <div id="first-name-label" class="first-name">
                    名字:
                </div>

                <div id="last-name" class="first-name-value">
                    
                </div>
            </div>

            <div class="first-name-container">
                <div id="first-name-label" class="first-name">
                    メールアドレス:
                </div>

                <div id="email" class="first-name-value">
                   
                </div>
            </div>

            <div class="first-name-container">
                <div id="first-name-label" class="first-name">
                    会員番号:
                </div>

                <div id="membership" class="first-name-value-mem">
                   
                </div>
            </div>


            <div class="referral-code-title">
                招待割引クーポン
            </div>

            <div class="first-name-container">
                <div id="first-name-label" class="first-name">
                    招待コード:
                </div>

                <div id="referral" class="first-name-value-ref">
                    
                </div>
            </div>

            <div class="referral-code-subtitle">
                招待コードを使用して友人がELEVATEアカウントにサインアップすると、イベントが10%オフになるクーポンをお互いに受け取ることができます。
            </div>
            
            <div class="coupons-container">
                <div class="coupons" v-for="doc in docs" :key="doc.id">
                <div class="coupons-container">
                    <img v-if="doc.data()['title'] == 'Referred coupon'" class="referral_coupon" src="./../assets/elevate-coupon.png" alt="Referral" height="150">
                    <img v-if="doc.data()['title'] == 'Referral coupon'" class="referral_coupon" src="./../assets/elevate-coupon.png" alt="Referral" height="150">
                </div>
            </div>
            </div>
            
            
            <div class="button-container">
                <button type="button" @click="logout()" id="logout" class="membership-number-submit">ログアウト</button>
            </div>
        </div>
        
    </div>
</template>

<style scoped>

.first-name-container {
    display: flex;
    flex-direction: row;
}

.referral_coupon {
    margin-left: 20px;
}

.coupons-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 10px;
}


.first-name {
    color: white;
        font-size: 14pt;
        font-family:  SFPRoLight;
        padding-bottom: 10px;
        padding-top: 4px;
        margin-left: 20px;
}

.first-name-value {
    color: white;
        font-size: 14pt;
        font-family:  SFPRoBold;
        padding-bottom: 10px;
        padding-top: 4px;
        margin-left: 10px;
}

.first-name-value-mem {
    color: rgb(225, 228, 99);;
        font-size: 14pt;
        font-family:  SFPRoBold;
        padding-bottom: 10px;
        padding-top: 4px;
        margin-left: 10px;
}


.first-name-value-ref {
    color: rgb(225, 228, 99);;
        font-size: 14pt;
        font-family:  SFPRoBold;
        padding-bottom: 10px;
        padding-top: 4px;
        margin-left: 10px;
}


.referral-code-title {
    color: white;
        font-size: 20pt;
        font-family:  SFPRoSemiBold;
        margin-left: 20px;
        margin-top: 15px;
}

.referral-code-subtitle {
        color: white;
        font-size: 14pt;
        font-family:  SFPRoRegular;
        margin-left: 20px;
        margin-top: 10px;
}

.text-container {
    text-align: left;
}
.hr {
    display: none;
}
    .upcoming-events-gallery {
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 320px 1fr 320px 1fr;
        grid-gap: 40px;
    }

    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background: none; 
        border: none;
    }

    .upcoming-events-title {
        font-family:  SFPRoSemiBold;
        font-size: 30pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-right: 20px;
    }
    
    .next-event-photo {
        width: 300px;
        height: 300px;
        border-radius: 12pt;
        object-fit: cover;
        cursor: pointer;
    }

    .event-subtitle {
        padding-bottom: 10px;
    }

    .event-photo {
        overflow: hidden;  
        border-radius: 12pt;
        background-color: red;  
        background: none; 
        border: none;
    }

    .event-date {
        color: white;
        font-size: 14pt;
        font-family:  SFPRoLight;
        padding-bottom: 10px;
        padding-top: 4px;
    }

.event-title {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoSemiBold;
    }

    .next-event-photo:hover {
    transform: scale(1.05); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    
    .next-event-photo {
        
    display: block;
    transition: transform .4s;   /* smoother zoom */
}

    .event-subtitle {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoRegular;
    }

    .nav-buttons {
        padding-right: 16px;
        display: flex;
        gap: 10px;
    }

    .enter-membership-form {
        background-color: rgb(35,32,38);
        /* display: flex; */
        width:auto;
        display: flex;
        flex-direction: column;
        margin-left:15px;
        margin-right:15px;
        margin-top: 50px;
        padding-bottom: 20px;
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        border-radius: 10px;
        margin-bottom: 40px;
    }

    .upcoming-events-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
    }

    .your-account-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
        margin-right: 16px
    }

    .upcoming-events-title {
        color: white;
    }

    .home-component {
        min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 20pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
         display: flex;
         justify-content: left;
         margin-left: 20px;
         margin-top: 35pt;
    }

    .session-detail-component-header-logo {
        height: 100pt;
        align-items: left;
        object-fit: contain;
        display: flex;
        justify-content: left;
        padding-left: 20pt;
    }

    .app-header {
        height: 100pt;
        width: 100%;
        justify-content: space-between;
        align-items: left;
        display: flex;
        
    }

    .app-header-nav-bar {
        height: 10pt;
        width: auto;
        justify-content: space-between;
        align-items: left;
        padding-right: 10pt;
        display: flex;
    }
    
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: gray;
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

    @media only screen and (max-width: 1000px) {
        .container {
        display: flex;
        flex-direction: column;
   }
}

@media only screen and (max-width: 1000px) {
   .upcoming-events-gallery {
        grid-template-columns: 1fr;
   }

   .hr {
    display: flex;
    width: 100%;
}
}

@media only screen and (max-width: 1000px) {
    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: row;
    }
    
    .next-event-photo {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }
}



.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 50pt;
    text-align: left;
    display: flex;
}

</style>

<script setup>
import { ref } from 'vue';
import { useRouter } from "vue-router";
import { useUserStore } from "@/piniastore";
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore"; 
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

const store = useUserStore();

const router = useRouter();

const docs = ref([]); // Create a ref for 'docs'

function logout() { 
    store.updateUser(null);
    store.updateReferralCode(null);
    router.push('/event-schedule');
 } 
 onMounted(async () => {
    NProgress.start()
    getDoc(doc(db, "users", store.user.uid))
        .then((result) => {
            const firstName = result.data()['first_name'];
            document.getElementById('first-name').innerHTML = firstName;

            const lastName = result.data()['last_name'];
            document.getElementById('last-name').innerHTML = lastName;

            const email = store.user.email;
            document.getElementById('email').innerHTML = email;

            const membershipNumber = result.data()['member_number'];
            document.getElementById('membership').innerHTML = "#" + String(membershipNumber).padStart(3, '0');

            const referralCode = result.data()['referral_code'];
            document.getElementById('referral').innerHTML = referralCode;

            const couponsRef = collection(db, "coupons");
            const queryReferral = query(couponsRef, where("owner_id", "==", store.user.uid));

            getDocs(queryReferral)
                .then((response) => {
                    NProgress.done()
                    docs.value = response.docs;
                })
                .catch((error) => {
                    NProgress.done()
                    alert(error.message)
                })
            
        })
        .catch((error) => {
            NProgress.done()
            alert(error.message)
        })
 })
</script>

<script>
import { db }  from '../main.js'
import { onMounted } from "vue";


export default {
    mounted () {
        window.scrollTo(0, 0);
        
    }
}
</script>
